import styled from "styled-components";
import Icon from "./icon";

const InfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	font-family: Roboto;
	margin-top: 1rem;
	margin-bottom: 1rem;
	background-color: #f2f8ff;
	padding: 1rem;
	border-radius: 10px;
`;

export const ConsentLanguage = styled.div`
	font-family: Roboto;
	font-size: 14px;
	line-height: 20px;
	margin-top: 1.5rem;
`;

export const Description = styled.div`
	font-family: Roboto;
	margin-top: 1rem;
	margin-bottom: 1rem;
	background-color: #f2f8ff;
	padding: 1rem;
	border-radius: 10px;

	ul {
		padding-left: 1rem;
		margin-top: 1rem;
		margin-bottom: 1rem;
	}

	li {
		margin-bottom: 0.5rem;
	}

	.heading {
		font-weight: 800;
	}
`;

export const InfoText = function ({ ...props }) {
	return (
		<InfoContainer>
			<Icon viewBox="0 0 256 256" icon="info" size={20} stroke="#004ECC" color="#004ECC" />
			<div style={{ display: "flex", flexDirection: "column" }}>
				<span style={{ fontFamily: "Roboto", fontSize: "16px", lineHeight: "16px", fontWeight: props.subtext ? "800" : "inherit" }}>{props.text}</span>
				{props.subtext && <span style={{ fontFamily: "Roboto", fontSize: "16px", lineHeight: "16px", marginTop: "4px" }}>{props.subtext}</span>}
			</div>
		</InfoContainer>
	);
};

export const Title = styled.div`
	font-size: 18px;
	font-family: Visby CF;
	line-height: 32px;
	font-weight: 600;
	color: #004ecc;
	margin-top: 2rem;
	margin-bottom: 1rem;
`;

export const Link = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 1.5rem;
	font-family: Roboto;
	align-items: center;

	.light-link {
		color: #565961;
		text-decoration: underline;
		font-size: 16px;
		font-weight: 400;
		cursor: pointer;
	}
`;

export const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
`;
